import actEnglish1 from '@backrs_ui/grow-ui/src/assets/images/satActBooster/act-english-1.png';
import actEnglish2 from '@backrs_ui/grow-ui/src/assets/images/satActBooster/act-english-2.png';
import actEnglish3 from '@backrs_ui/grow-ui/src/assets/images/satActBooster/act-english-3.png';
import actMath1 from '@backrs_ui/grow-ui/src/assets/images/satActBooster/act-math-1.png';
import actMath2 from '@backrs_ui/grow-ui/src/assets/images/satActBooster/act-math-2.png';
import actMath3 from '@backrs_ui/grow-ui/src/assets/images/satActBooster/act-math-3.png';
import actMath4 from '@backrs_ui/grow-ui/src/assets/images/satActBooster/act-math-4.png';
import actMath5 from '@backrs_ui/grow-ui/src/assets/images/satActBooster/act-math-5.png';
import actMath6 from '@backrs_ui/grow-ui/src/assets/images/satActBooster/act-math-6.png';
import actReading1 from '@backrs_ui/grow-ui/src/assets/images/satActBooster/act-reading-1.png';
import actReading2 from '@backrs_ui/grow-ui/src/assets/images/satActBooster/act-reading-2.png';
import actReading3 from '@backrs_ui/grow-ui/src/assets/images/satActBooster/act-reading-3.png';
import actScience1 from '@backrs_ui/grow-ui/src/assets/images/satActBooster/act-science-1.png';
import actScience2 from '@backrs_ui/grow-ui/src/assets/images/satActBooster/act-science-2.png';
import actScience3 from '@backrs_ui/grow-ui/src/assets/images/satActBooster/act-science-3.png';
import actTimed from '@backrs_ui/grow-ui/src/assets/images/satActBooster/act-timed.png';
import satMath1 from '@backrs_ui/grow-ui/src/assets/images/satActBooster/sat-math-1.png';
import satMath2 from '@backrs_ui/grow-ui/src/assets/images/satActBooster/sat-math-2.png';
import satMath3 from '@backrs_ui/grow-ui/src/assets/images/satActBooster/sat-math-3.png';
import satMath4 from '@backrs_ui/grow-ui/src/assets/images/satActBooster/sat-math-4.png';
import satRw1 from '@backrs_ui/grow-ui/src/assets/images/satActBooster/sat-rw-1.png';
import satRw2 from '@backrs_ui/grow-ui/src/assets/images/satActBooster/sat-rw-2.png';
import satRw3 from '@backrs_ui/grow-ui/src/assets/images/satActBooster/sat-rw-3.png';
import satRw4 from '@backrs_ui/grow-ui/src/assets/images/satActBooster/sat-rw-4.png';
import satTimed from '@backrs_ui/grow-ui/src/assets/images/satActBooster/sat-timed.png';
import { DailyResource } from '@backrs_ui/grow-ui/src/pages/SatActBooster/utils/dailyResource';
import { TargetTest } from '@backrs_ui/grow-ui/src/redux/satActBooster/satActBooster.types';

/**
 * Study-day artwork keyed on the reporting-category code. Keyed on the code rather than the
 * category id or study-unit URL because ACT and SAT categories can share a study unit but need
 * distinct art. The artwork is one motif per section in a per-category colorway, so the pairing
 * below only has to stay stable — a category must not change art between days.
 *
 * The rollup (`act_math_phm`) and cross-cutting (`act_math_mod`) codes are absent by design: they
 * are never a day's focus, and leave the card's skeleton in place if they ever surface.
 */
const CATEGORY_IMAGES: Readonly<Record<string, string>> = {
  act_eng_pow: actEnglish1,
  act_eng_kol: actEnglish2,
  act_eng_cse: actEnglish3,
  act_math_phm_nq: actMath1,
  act_math_phm_alg: actMath2,
  act_math_phm_fn: actMath3,
  act_math_phm_geo: actMath4,
  act_math_phm_sp: actMath5,
  act_math_ies: actMath6,
  act_read_kid: actReading1,
  act_read_acs: actReading2,
  act_read_iki: actReading3,
  act_sci_iod: actScience1,
  act_sci_sin: actScience2,
  act_sci_emi: actScience3,
  sat_rw_info: satRw1,
  sat_rw_craft: satRw2,
  sat_rw_expr: satRw3,
  sat_rw_conv: satRw4,
  sat_math_alg: satMath1,
  sat_math_adv: satMath2,
  sat_math_data: satMath3,
  sat_math_geo: satMath4,
};

/** Timed-day artwork, one image per test across every section. */
const PRACTICE_TEST_IMAGES: Readonly<Record<TargetTest, string>> = {
  act: actTimed,
  sat: satTimed,
};

/** The day's card artwork; null when nothing is mapped, which holds the skeleton. */
export const resourceImageSrc = (resource: DailyResource): string | null => {
  if (resource.kind === 'practiceTest') return PRACTICE_TEST_IMAGES[resource.test];

  return resource.categoryCode ? (CATEGORY_IMAGES[resource.categoryCode] ?? null) : null;
};
